// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_6s-3";
export var contentContainer = "_6s-0";
export var editorContainer = "_6s-1";
export var quillInputForm = "_6s-2";
export var zoneDivider = "_6s-4";